import {request} from './request'

//运维列表
export function getOperatorList(data){
  return request(
    {
     url:'/admin/getDevOps',
     method:'post',
     data,
     headers:{
       "Content-Type":'application/json;charset=UTF-8'
     }
    }
  )
}

//添加运维
export function addOperator(data){
  return request(
    {
     url:'/admin/addDevOps',
     method:'post',
     data,
     headers:{
       "Content-Type":'application/json;charset=UTF-8'
     }
    }
  )
}

//重新绑定
export function changeOperator(data){
  return request(
    {
     url:'/admin/updDeviceBind',
     method:'post',
     data,
     headers:{
       "Content-Type":'application/json;charset=UTF-8'
     }
    }
  )
}

//用户更好运维
export function changeCustomerOperator(data){
  return request(
    {
     url:'/admin/usrBindDevOps',
     method:'post',
     data,
     headers:{
       "Content-Type":'application/json;charset=UTF-8'
     }
    }
  )
}


//修改运维
export function editOperator(data){
  return request(
    {
     url:'/admin/updDevOps',
     method:'post',
     data,
     headers:{
       "Content-Type":'application/json;charset=UTF-8'
     }
    }
  )
}

//删除运维
export function deleteOperator(id){
  return request(
    {
     url:'/admin/delDevOps',
     method:'post',
     data:id,
     headers:{
       "Content-Type":'application/json;charset=UTF-8'
     }
    }
  )
}

//查询设备型号
export function getTypeList(data='{}'){
  return request(
    {
     url:'/admin/getDeviceType',
     method:'post',
     data,
     headers:{
       "Content-Type":'application/json;charset=UTF-8'
     }
    }
  )
}

//添加设备型号
export function addDevice(data){
  return request(
    {
     url:'/admin/addDeviceType',
     method:'post',
     data,
     headers:{
       "Content-Type":'application/json;charset=UTF-8'
     }
    }
  )
}

//删除设备型号
export function deleteDevice(id){
  return request(
    {
     url:'/admin/delDeviceType',
     method:'post',
     data:id,
     headers:{
       "Content-Type":'application/json;charset=UTF-8'
     }
    }
  )
}

//查询设备列表
export function getDeviceList(data){
  return request(
    {
     url:'/devops/getAdminDeviceList',
     method:'post',
     data,
     headers:{
       "Content-Type":'application/json;charset=UTF-8'
     }
    }
  )
}

//查询设备详情
export function getDeviceDetail(data){
  return request(
    {
     url:'/devops/getAdminDeviceInfo',
     method:'post',
     data,
     headers:{
       "Content-Type":'application/json;charset=UTF-8'
     }
    }
  )
}

//查询客户列表
export function getCustomerList(data){
  return request(
    {
     url:'/devops/getUsr',
     method:'post',
     data,
     headers:{
       "Content-Type":'application/json;charset=UTF-8'
     }
    }
  )
}

//获取验证码
export function getVerify(data){
  return request(
    {
     url:'/admin/getCode',
     method:'post',
     data,
     headers:{
       "Content-Type":'application/json;charset=UTF-8'
     }
    }
  )
}

//厂商密码登录
export function login(id){
  return request(
    {
     url:'/admin/login',
     method:'post',
     data:id,
     headers:{
       "Content-Type":'application/json;charset=UTF-8'
     }
    }
  )
}

//厂商验证码登录
export function codeLogin(id){
  return request(
    {
     url:'/admin/codeLogin',
     method:'post',
     data:id,
     headers:{
       "Content-Type":'application/json;charset=UTF-8'
     }
    }
  )
}

//修改客户
export function editCustomer(data){
  return request(
    {
     url:'/devops/updUsr',
     method:'post',
     data,
     headers:{
       "Content-Type":'application/json;charset=UTF-8'
     }
    }
  )
}

//删除客户
export function deleteCustomer(id){
  return request(
    {
     url:'/devops/delUsr',
     method:'post',
     data:id,
     headers:{
       "Content-Type":'application/json;charset=UTF-8'
     }
    }
  )
}



// WEBPACK FOOTER //
// ./src/api/api.js